module.exports = __webpack_public_path__ + "static/hero-b832a98858b05b3356b04c38a50466c5.png";